import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Navbar from 'tbk-components/src/components/NavBar';
export interface IDonorToolHeaderProps extends IBaseElementProps {
	logo?: IImage;
	logoURL?: string;
	myAccountLink?: string;
	backToMainSiteLinkText?: string;
	backToDonorToolLinkText?: string;
	backToDonorToolLinkURL?: string;
	headerCalloutOneImage?: IImage;
	headerCalloutOneText?: string;
	headerCalloutTwoImage?: IImage;
	headerCalloutTwoText?: string;
	cartAmount?: number;
	cartURL?: string;
}

const DonorToolHeader: React.FC<IDonorToolHeaderProps> = ({
	className,
	classNames = [],
	logo,
	logoURL,
	myAccountLink,
	backToMainSiteLinkText,
	backToDonorToolLinkText,
	backToDonorToolLinkURL,
	headerCalloutOneImage,
	headerCalloutOneText,
	headerCalloutTwoImage,
	headerCalloutTwoText,
	cartAmount = 0,
	cartURL,
}) => {
	return (
		<header
			className={
				className || cn('header donor-tool-header', ...classNames)
			}
		>
			<Navbar
				logo={logo}
				logoURL={logoURL}
				background={'white'}
				useCollapse={true}
				useOffcanvas={false}
				isSticky={false}
				className="navbar navbar-expand-md navbar-white bg-white"
			>
				<div className="donor-tool-header__right">
					<div className="donor-tool-header__callout-containers">
						<div className="donor-tool-header__callout">
							{headerCalloutOneImage && (
								<Image {...headerCalloutOneImage} />
							)}
							{headerCalloutOneText && (
								<div className="donor-tool-header__callout-text">
									<p>{headerCalloutOneText}</p>
								</div>
							)}
						</div>
						<div className="donor-tool-header__callout second-callout">
							{headerCalloutTwoImage && (
								<Image {...headerCalloutTwoImage} />
							)}
							{headerCalloutOneText && (
								<div className="donor-tool-header__callout-text">
									<p>{headerCalloutTwoText}</p>
								</div>
							)}
						</div>
					</div>
					<div className="donor-tool-header__button-container">
						{myAccountLink && (
							<div className="donor-tool-header__my-account-link">
								<a
									id="my-account-link"
									className="btn btn-light-text"
									href={myAccountLink}
									aria-label="My Account"
								>
									<i className="icon icon-person-icon"></i>
								</a>
							</div>
						)}
						<div className="donor-tool-header__shopping-cart-link">
							<a
								className="btn btn-light-text position-relative"
								href={cartURL}
								aria-label="Shopping Cart"
							>
								<div className="cart-amount-wrapper" />
								<i className="icon icon-shopping-cart-solid"></i>
							</a>
						</div>
					</div>
				</div>
			</Navbar>
			<div className="donor-tool-header__bottom">
				<a
					className="donor-tool-header__bottom-link"
					href={logoURL}
					aria-label={backToMainSiteLinkText}
				>
					<i className="icon icon-chevron-left"></i>
					{backToMainSiteLinkText && backToMainSiteLinkText}
				</a>
				{backToDonorToolLinkText && backToDonorToolLinkURL &&
					<a
						className="donor-tool-header__bottom-link"
						href={backToDonorToolLinkURL}
						aria-label={backToDonorToolLinkText}
						>
						<i className="icon icon-chevron-left"></i>
						{backToDonorToolLinkText}
					</a>
				}
			</div>
		</header>
	);
};

export default DonorToolHeader;
